module.exports = __webpack_public_path__ + "img/GR099.29f4523c.png";